import leftChevron from './icons/leftChevron.svg';
import rightChevron from './icons/rightChevron.svg';
import link from './icons/link.svg';
import close from './icons/close.svg';

const show = {
  analytics: true,
  myAccount: true,
  newsletter: true,
  partners: true,
  faq: true,
  permissions: {
    toggleAll: true
  },
  products: {
    optOutEverything: true
  }
};

const palette = {
  blue: '#006699',
  lightBlue: '#3C81BE',
  black: '#1D1D1B',
  darkGrey: '#333333',
  grey: '#696969',
  lightGrey: '#F3F0EF',
  green: 'green'
};

const colours = {
  primary: palette.blue,
  link: palette.blue,
  accent: palette.black,
  info: palette.lightBlue,
  bg: 'white',
  bgContrast: 'white',
  alert: palette.darkGrey,
  black: palette.black,
  border: palette.grey,
  muted: palette.grey,
  hover: palette.lightGrey,
  positive: palette.green,
  banner: {
    background: palette.yellow,
    primary: palette.black,
    secondary: palette.black
  }
};

const borders = {
  radius: 0,
  box: '',
  width: '1px'
};

const whitespace = {
  xs: '5px',
  small: '10px',
  base: '15px',
  large: '20px',
  xl: '30px',
  addon: 0,
  gutter: '15px'
};

const type = {
  base: {
    fontFamily: 'helvetica, sans-serif',
    color: colours.black,
    fontSize: '16px'
  },
  title: {
    fontSize: '30px'
  },
  h1: {
    fontSize: '30px'
  },
  h2: {
    fontSize: '26px'
  },
  h3: {
    fontSize: '20px'
  },
  lead: {},
  small: {
    fontSize: '14px',
    color: colours.muted
  },
  notice: {
    textAlign: 'left'
  },
  link: {
    color: colours.link,
    textDecoration: 'underline'
  },
  modal:{
    background: 'white',
    maxWidth: '500px',
    padding: whitespace.large,
    outline: 'none',
    boxSizing: 'border-box',
    borderRadius: borders.radius
  }
};

const icons = {
  leftChevron,
  rightChevron,
  link,
  close
};

const strings = {
  channel: {
    sms: { displayName: 'SMS', order: 4 },
    post: { displayName: 'Post', order: 3 },
    email: { displayName: 'Email', order: 1 },
    phone: { displayName: 'Phone', order: 2 },
    data: { displayName: 'Data', order: 5 }
  }
};

const misc = {
  appWidth: '620px'
};

export default {
  show,
  palette,
  colours,
  whitespace,
  type,
  icons,
  borders,
  strings,
  misc
};
